// Step -1 Add Mutual Fund
export const ADD_MUTUAL_FUND_START = "ADD_MUTUAL_FUND_START"
export const ADD_MUTUAL_FUND_SUCCESS = "ADD_MUTUAL_FUND_SUCCESS"
export const ADD_MUTUAL_FUND_FAILURE = "ADD_MUTUAL_FUND_FAILURE"
export const ADD_MUTUAL_FUND_RESET = "ADD_MUTUAL_FUND_RESET"

// Step -2 Update Mutual Fund
export const UPDATE_MUTUAL_FUND_START = "UPDATE_MUTUAL_FUND_START"
export const UPDATE_MUTUAL_FUND_SUCCESS = "UPDATE_MUTUAL_FUND_SUCCESS"
export const UPDATE_MUTUAL_FUND_FAILURE = "UPDATE_MUTUAL_FUND_FAILURE"
export const UPDATE_MUTUAL_FUND_RESET = "UPDATE_MUTUAL_FUND_RESET"

// Step -3 View Customer Mutual Fund
export const VIEW_CUSTOMER_MUTUAL_FUND_START = "VIEW_CUSTOMER_MUTUAL_FUND_START"
export const VIEW_CUSTOMER_MUTUAL_FUND_SUCCESS = "VIEW_CUSTOMER_MUTUAL_FUND_SUCCESS"
export const VIEW_CUSTOMER_MUTUAL_FUND_FAILURE = "VIEW_CUSTOMER_MUTUAL_FUND_FAILURE"
export const VIEW_CUSTOMER_MUTUAL_FUND_RESET = "VIEW_CUSTOMER_MUTUAL_FUND_RESET"

// Step -4 View Single Mutual Fund
export const VIEW_SINGLE_MUTUAL_FUND_START = "VIEW_SINGLE_MUTUAL_FUND_START"
export const VIEW_SINGLE_MUTUAL_FUND_SUCCESS = "VIEW_SINGLE_MUTUAL_FUND_SUCCESS"
export const VIEW_SINGLE_MUTUAL_FUND_FAILURE = "VIEW_SINGLE_MUTUAL_FUND_FAILURE"
export const VIEW_SINGLE_MUTUAL_FUND_RESET = "VIEW_SINGLE_MUTUAL_FUND_RESET"

// Step -5 GET Mutual Fund Report
export const MUTUAL_FUND_REPORT_START = "MUTUAL_FUND_REPORT_START";
export const MUTUAL_FUND_REPORT_SUCCESS = "MUTUAL_FUND_REPORT_SUCCESS";
export const MUTUAL_FUND_REPORT_FAILURE = "MUTUAL_FUND_REPORT_FAILURE";
export const MUTUAL_FUND_REPORT_RESET = "MUTUAL_FUND_REPORT_RESET";